import { Error } from './user-attribute.model';

export interface LrsList {
    count: number;
    data: LrsDetails [];
    status: number;
    total: number;
    errors: Error[];
}

export interface LrsDetails {
    creditLoss: number;
    frequencyValue: string;
    interestAmount: number;
    investmentAmount: number;
    nCashAmount: number;
    portfolioId: string;
    productCode: string;
    status: string;
    withdrawalAmount: number;
    principalOutstanding: number;
    interestWdAmount?: number
}

export enum LrsFrequency {
    DAILY = 'DAILY',
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY',
}